import { CodeModel } from "./models/code.model";

export const administrationConst = {    
    bankAccount: "/bank-account",
    bankAccountChanges: "/bank-account-changes",
    deleteBankAccount: "/bank-account-delete",
    bankAccounts: "/bank-accounts",
    imprestVendors: "/imprest-vendors",
    imprestVendorsChanges: "/imprest-vendors-changes",
    addressBookAlphaName: "/address-book-alpha-name/",
    payGradeBenefits: "/pay-grade-benefits",
    benefitCodes: "/benefit-codes",
    treasuryRate: "/treasury-rate",
    treasuryRateAdd: "/treasury-rate-add",
    treasuryRateDelete: "/treasury-rate-delete",
    distance: "/distance",
    town: "/town",
    townDistance: "/town-distance",
    distanceChanges: "/distance-changes",
    employeeCategory: "/employee-category",
    employeeCategoryChanges: "/employee-categories-changes",
    user: "/user",
    requestLineTypes: "/request-and-line-types",
    requestTypesChanges: "/request-type-changes",
    lineTypeChanges: "/line-type-changes",
    lineTypes: "/line-types",
    requestType: "/request-type/",
    imprestVendorsCheck: "/imprest-vendors-check/",
    lineType: "/line-type",
    lineTypeByRequest: "/line-type-by-request",
    lineTypeAccount: "/line-type-account",
}

export const doaTypes: CodeModel[] = [
    { code: "N", description: "N - Expense Reports (GO-165)" },
    { code: "O", description: "O - Expense Advance (GO-1523)" },
    { code: "P", description: "P - Moving Expense (GO166)" },
    { code: "Q", description: "Q - Petty Cash GO156 Disbursement" },
    { code: "X2", description: "X2 - Approved Imprest Reimbursement" },
    { code: "T", description: "T - Other Expenditure Payment (GO63)" }
  ];

export const approverTypes: CodeModel[] = [
{ code: "*SUP", description: "Supervisor" },
{ code: "SA", description: "Specific Approver"},
{ code: "", description: "None"}
];

export const promptTypes: CodeModel[] = [
  { code: "D", description: "Description Field" },
  { code: "DD", description: "Date Difference" },
  { code: "DS", description: "Distance" },
  { code: "F", description: "Fixed Value" },
  { code: "N", description: "Numeric Factor" }
]
